import React, { Component } from 'react';
import InputText, { InputSelect, InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline.jsx';
import FormLayout from '../containers/FormLayout.jsx';
import { Box, Button, Grid } from '@material-ui/core';
import DatePicker from '../../../../commonModules/MUI/DatePicker.jsx';
import { Alert, AlertTitle } from '@material-ui/lab';

class FormResaDemand extends Component {
    state = { }
    
    createShopList = () => {
        const list = []
        const { SHOPS, AVAILABLE} = this.props
        if( AVAILABLE ){
            Object.values(SHOPS).map( shop => { 
                let selected = !!shop.shop_disabled || this.props.resa.shop_id === shop.id
                
                list.push (       
                    {value:shop.id, label:shop.name, disabled:selected} 
                )
            })
        }
        return list
    }

    render() {
        const shops = this.createShopList()
        return (
            <Grid className="card-text">
                <h4 className="card-title">Nouvelle Réservation</h4>

                <Box p={2}>
                    <Grid container spacing={2} >
                        {/* <Grid item xs={12}>
                            <InputSelectMagasin
                                options={[
                                    {value:"mjb", label:"Plateforme MyJouleBox"},
                                    {value:"other", label:"Autre plateforme"},
                                ]}
                                value={this.props.resa.cli_typeDisplay}
                                onChange={(option) => this.props.handleSelect(option, "cli_type")}
                                error={this.props.errors.cli_type}
                                label="Type Client"
                            /> 
                        </Grid> */}
                        
                        <Grid item xs={12} sm={6}>
                            <InputSelectMagasin
                                options={shops}
                                value={this.props.resa.shop_idDisplay}
                                onChange={(option) => this.props.handleSelect(option,"shop_id")}
                                error={this.props.errors.shop_id}
                                label="Magasin"
                            /> 
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DatePicker 
                                label="Date d'utilisation prévue"
                                minDate={new Date()}
                                value={this.props.resa.usage_date}
                                onChange={this.props.handleChangeDate}
                            />
                        </Grid>
                        
                        <Grid item xs={12}>
                            {this.props.resa.shop_id &&
                                <Alert severity="info">
                                    <AlertTitle>Les produits en vert sont déjà disponible dans votre magasin</AlertTitle>
                                    Pour un traitement plus rapide de votre demande, privilégiez ces produits.
                                </Alert>
                            }
                            <FormLayout 
                                // title={"Produits"}
                                {...this.props} 
                                createAddForm={this.props.createAddForm}
                                onClick={this.props.handleAddProd}
                                onClickForCSVUpload={this.props.handleAddProdByCSV}
                                rea
                                // resaDemand
                                colSpan={2}
                            /> 
                        </Grid>
                        <Grid item xs={12} >
                            <InputText
                                multiline
                                rows={4}
                                value={this.props.resa.comments}
                                name="comments"
                                onChange={this.props.handleChange}
                                error={this.props.errors.comments}
                                label="Commentaires"
                            />
                        </Grid>
                    </Grid>
                        
                    {/* <Box p={2} >
                        <div className="pull-right">
                            <Button color="secondary" variant="contained" onClick={this.props.validate}>Valider</Button>
                            <Button color="secondary" onClick={this.props.handleClose}>Annuler</Button>
                        </div>                    
                    </Box> */}
                </Box>
            </Grid>
        );
    }
}

export default FormResaDemand;